module.exports = __webpack_public_path__ + "static/media/icon-umkm.5ab50233.png";